import { HttpInterceptor,HttpRequest,HttpHandler,HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import {Observable} from 'rxjs';
// import { environment } from "src/environments/environment";
import {environment} from "../environments/environment"

import { catchError, finalize, tap } from 'rxjs/operators';
import { datadogRum } from '@datadog/browser-rum';
import Swal from 'sweetalert2/dist/sweetalert2.js';
export class CustomInterceptor implements HttpInterceptor{
     authtoken;
    intercept(request: HttpRequest<any>, next:HttpHandler): Observable<HttpEvent<any>> {

        //  console.log("in interceptor",request.url);


        // if(request.url.includes("localhost") || request.url.includes(environment.apiURL)|| request.url.includes(environment.JavaUrlEndPoint) )
        if(request.url.includes("localhost") || request.url.includes(environment.apiURL)|| request.url.includes(environment.smartReportURL) || request.url.includes(environment.apiURLThread) )
        {
            // console.log('intercepting');
            // console.log("token id : ", JSON.parse(sessionStorage.getItem('2ebc4550-936a-44b6-b7c9-eae1fb287454-b2c_1_logindemov2.4da207a1-0130-43ac-93c2-52960d47390a-nebulogicsmart.b2clogin.com-idtoken-676a12b0-6624-460f-83a8-59d9cd4b9a4c----')).secret);
                //  let authtoken=
                // console.log(Object.keys(sessionStorage));

                Object.keys(sessionStorage).forEach(element => {
                    // console.log(element.match("idtoken"));
                    if(element.match("idtoken")){
                          this.authtoken=element

                    }

                });
            if(environment.dev_mode == 'FALSE' && !request.url.includes('geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest') &&
            !request.url.includes('gis.acimap.us/311/rest/services/locator') && !request.url.includes('tableau.thesmartice.com')){
                // console.log(request.url.includes('geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest'))
                request = request.clone({
                    setHeaders: {
                        // Authorization: localStorage.getItem('msal.idtoken')+""

                        // Authorization:JSON.parse(sessionStorage.getItem('6d27f133-f47b-436e-962d-ca6f284bce96-b2c_1_logindemov2.4da207a1-0130-43ac-93c2-52960d47390a-nebulogicsmart.b2clogin.com-idtoken-676a12b0-6624-460f-83a8-59d9cd4b9a4c----')).secret

                        Authorization:JSON.parse(sessionStorage.getItem(this.authtoken)).secret
                        // Authorization:JSON.parse(sessionStorage.getItem(this.authtoken)).secret

                    }
                });
            } else {
                request = request.clone({
                    setHeaders: {
                        // Authorization: localStorage.getItem('msal.idtoken')+""

                        // Authorization:JSON.parse(sessionStorage.getItem('6d27f133-f47b-436e-962d-ca6f284bce96-b2c_1_logindemov2.4da207a1-0130-43ac-93c2-52960d47390a-nebulogicsmart.b2clogin.com-idtoken-676a12b0-6624-460f-83a8-59d9cd4b9a4c----')).secret

                        //Authorization:JSON.parse(sessionStorage.getItem(this.authtoken)).secret
                        // Authorization:JSON.parse(sessionStorage.getItem(this.authtoken)).secret

                    }
                });
            }
            //return next.handle(request);

        }
        const payload = request.body;
        // return next.handle(request);
        return next.handle(request).pipe(
          tap(
            (event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                // Log success and request payload to Datadog
                console.log(event.body);
                datadogRum.addAction(request.method+' request success', {
                  url: request.url,
                  payload: request.method === 'POST' || request.method === 'PUT' ? JSON.stringify(request.body) : JSON.stringify(payload),
                  response: event.body,
                  status: 'success',

                });
              }
            },
            (error: HttpErrorResponse) => {              
              // Log error and request payload to Datadog
               Swal.fire({
                          title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong,Please refresh the page and try again. If problem persists please contact support.</div></div>',
                          //html:data,
                          icon: 'error',
                          imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                          imageHeight: 45,
                          showCloseButton: true,
                          showCancelButton: false,
                          focusConfirm: false,
                          confirmButtonText: `OK`,
                          cancelButtonText: 'Cancel'
                        })
              datadogRum.addAction('request failure', {
                url: request.url,
                payload: JSON.stringify(payload),
                error: error.message,
                status: 'error',
              });
            }
          )
        );

    }

}
